import { TabContainer, TabList, Tab } from "./style";

const SimpleTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabContainer>
      <TabList>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            $active={activeTab === tab.id}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>
    </TabContainer>
  );
};

export default SimpleTabs;
